import Vue from 'vue'

export const downloadFile = async (uri, name) => {
  await fetch(uri).then(res => res.blob().then(blob => {
    const a = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = name
    a.click()
    window.URL.revokeObjectURL(url)
  }))
}

export const copy = text => {
  const oInput = document.createElement('input')
  oInput.value = text
  document.body.appendChild(oInput)
  oInput.select() // 选择对象
  document.execCommand('Copy') // 执行浏览器复制命令
  oInput.className = 'oInput'
  oInput.style.display = 'none'
  document.body.removeChild(oInput)
  let instance = new Vue()
  instance.$message.success('复制成功！')
}

/**
 * @return {'qa'|'pre'|'prod'}
 * */
export const getEnv = () => {
  const { host } = window.location
  const isDev = /qa\.kminghealth\.com$/
  const isPre = /pre\.kminghealth\.com$/
  if (host.match(isDev)) return 'qa'
  if (host.match(isPre)) return 'pre'
  if (!host.match(isDev) && !host.match(isPre)) return 'prod'
  return 'qa'
}

const zyPayBaseUrlMap = {
  qa: '//apigw.qa.kminghealth.com/api/',
  pre: '//apigw.pre.kminghealth.com/api/',
  prod: '//apigw.kminghealth.com/api/'
}
export const getZYPayBaseUrl = () => {
  const env = getEnv()
  return zyPayBaseUrlMap[env]
}
